
export function getStatusColor(status, entity) {
    switch (status) {
        case 'RUNNING': return entity == 'Game' ? 'orange' : 'success';
        case 'ACTIVE': return 'success';
        case 'FINISHED': return 'success';
        case 'NOTSTARTED': return 'orange';
        case 'OPEN_FOR_REGISTRATION': return 'pink';
        case 'FINISHED': return null;
        case 'CANCELLED': return null;
        case 'POSTPONED': return 'red';
        case 'NOT REGISTERED': return 'orange';
        case 'NOT PLAYED': return null;
        case 'DRAFT': return 'orange';
        case 'PREAPPROVED': return 'processing';
        case 'INVITED': return 'pink';
        // registration:
        case 'NEW': return 'orange';
        case 'PROCESSED': return 'green';
        case 'REJECTED': return 'red';
        // season player registration:
        case 'WAITING': return 'orange';
        case 'NOT_CONFIRMED': return 'orange';
        case 'CONFIRMED': return 'green';
        case 'UNPAID': return 'orange';
        case 'PAID': return 'green';
        case 'FREE': return 'green';

    
    
    }
}

export function getStatusText(status, entity) {
    return {
        'NOTSTARTED': 'NOT STARTED',
        'OPEN_FOR_REGISTRATION': 'OPEN FOR REGISTRATION',
        'INVITED': 'INVITED',
        'NOT_CONFIRMED': 'NOT CONFIRMED',
    }[status] ?? status;
}

export function getPaymentStatusOfSeasonPlayerRegistration(reg) {
    const season = reg.Season;
    if (!season.playerRegFeeMandatory) {
        return 'FREE';
    }
    if (reg.isPaid) {
        return 'PAID';
    }
    return 'UNPAID';
}

export function getRegStatusOfSeasonPlayerRegistration(reg) {
    return reg.isConfirmed ? 'CONFIRMED' : 'NOT_CONFIRMED';
}
